<template>
  <div
    class="mx-auto mt-3 d-flex flex-column align-items-center"
    style="border-radius: 20px; height: 80vh; position: relative"
  >
    <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'لیبل محصول'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <v-img :src="value.photo.profile" class="image_style"></v-img>
    <v-card
      elevation="2"
      :color="value.pallete.headColor"
      rounded="xl"
      class="position-relative d-flex flex-column align-items-center justify-content-center"
      :style="{
        width: '80%',
        height: '20vh',
        background: !!value.photo.headBackground
          ? 'transparent'
          : value.pallete.headColor,
      }"
    >
      <div
        v-if="!!value.photo.headBackground"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${value.photo.headBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          opacity: 0.1,
        }"
      ></div>
      <v-card-title
        elevation="2"
        class="d-flex justify-content-center marquee-container mr-6"
        :style="{ maxWidth: fixedWidth + 'px' }"
      >
        <span
          ref="textRef"
          :class="{ 'marquee-text': isOverFlowLabel }"
          :style="{
            color: value.pallete.textColor,
            fontSize: '30px',
            fontWeight: '800',
            zIndex: 1,
          }"
          >{{ value.label.labelName.text }}</span
        >
      </v-card-title>
      <v-card-title
        class="d-flex justify-content-center marquee-container ml-4"
        :style="{ maxWidth: fixedWidth + 'px' }"
      >
        <span
          ref="textName"
          :class="{ 'marquee-text': isOverFlowLabelName }"
          :style="{
            color: value.pallete.textColor,
            fontSize: '20px',
            fontWeight: '400',
            zIndex: 1,
          }"
          >{{ value.label.name.text }}</span
        >
      </v-card-title>
    </v-card>

    <div class="badge-wrapper">
      <div v-if="value?.label?.discount?.text" class="badge d-flex flex-col">
        <span>{{ persian(value?.label?.discount?.text) }}%</span>
        <span>off</span>
      </div>
    </div>

    <!-- منو  -->
    <v-card
      elevation="1"
      :style="{
        background: value.pallete.headColor,
        width: '4rem',
        maxHeight: '500px',
        zIndex: '99',
        padding: '5px 0',
        bottom:
          socialMediaSlice.length > 2
            ? socialMediaSlice.length < 8
              ? `${50 - socialMediaSlice.length * 6}%`
              : `0`
            : null,
      }"
      v-if="socialMediaSlice.length > 0 && feedbackShow === 1"
      rounded="xxl"
      class="menu d-flex flex-column align-items-center"
    >
      <div class="d-flex flex-column align-items-center">
        <v-tooltip
          v-if="
            socialMediaSlice?.length === socialMedia?.length &&
            socialMediaSlice?.length > 2
          "
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="white"
              height="50"
              class="social mt-1"
              style="cursor: pointer"
              @click="deletSocialMedia"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <span>کمتر</span>
        </v-tooltip>

        <v-tooltip
          v-if="
            socialMediaSlice?.length < socialMedia?.length &&
            socialMedia.length > 2
          "
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="white"
              height="40"
              class="social my-1"
              style="cursor: pointer"
              @click="addSocialMedia"
            >
              mdi-dots-horizontal
            </v-icon>
          </template>
          <span>بیشتر</span>
        </v-tooltip>

        <v-tooltip v-if="value.FeedBack?.items?.length > 0" right>
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              target="_blank"
              class="social mt-1 animated-social"
              style="
                width: 40px;
                height: 50px;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;
              "
              @click="feedbackShow = 2"
            >
              <v-img
                :src="feedbackicons.img"
                contain
                style="width: 100%; height: 100%"
              />
            </a>
          </template>
          <span>{{ feedbackicons.label }}</span>
        </v-tooltip>
      </div>

      <div
        class="w-100 scrollable-icons"
        style="overflow-y: auto; max-height: 400px"
      >
        <div class="d-flex flex-column align-items-center">
          <v-tooltip v-for="(social, i) in socialMediaSlice" :key="i" right>
            <template v-slot:activator="{ on, attrs }">
              <a
                v-bind="attrs"
                v-on="on"
                @click="goToUrl(social.url, social.pattern)"
                target="_blank"
                class="social mt-1 animated-social"
                style="
                  width: 40px;
                  height: 50px;
                  border-radius: 50%;
                  overflow: hidden;
                  cursor: pointer;
                "
              >
                <v-img
                  :src="social.img"
                  contain
                  style="width: 100%; height: 100%"
                />
              </a>
            </template>
            <span>{{ social.label }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-card>

    <!-- product -->
    <v-card
      class="mt-5 mx-auto"
      :style="{
        position: 'relative',
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '80%',
        minHeight: '60vh',
        borderRadius: '15px',
        background: !!value.photo.background
          ? 'transparent'
          : value.pallete.bodyColor,
      }"
      ref="card_label"
    >
      <!-- تصویر پس‌زمینه -->
      <div
        v-if="!!value.photo.background"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: `${imageHeight}px`,
          backgroundImage: `url(${value.photo.background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          opacity: 0.1,
        }"
        ref="imageBackground"
      ></div>

      <v-stepper
        ref="myStepper"
        flat
        style="background: transparent"
        v-model="feedbackShow"
        class="pa-0"
      >
        <v-stepper-items style="background: transparent" class="pa-0">
          <v-stepper-content
            style="background: transparent"
            color="transparent"
            class="pa-0"
            step="1"
          >
            <!-- 
              اصلاح مهم در این قسمت:
              به جای دستکاری width و له کردن محتوا، از padding هوشمند برای 
              خالی کردن جای منو استفاده کردیم و box-sizing را روی border-box گذاشتیم 
            -->
            <div
              ref="menuBackground"
              class="pb-4"
              :style="{
                color: value.pallete.textColor,
                width: '100%',
                paddingLeft:
                  socialMediaSlice.length > 0 && feedbackShow === 1
                    ? '75px'
                    : '10px',
                paddingRight: '15px',
                boxSizing: 'border-box',
                transition: 'padding 0.3s ease',
              }"
            >
              <drag-list v-model="label" style="width: 100%">
                <template v-slot:default="{ item }">
                  <template
                    v-if="
                      item === 'bPrice' &&
                      isValidValue(value.label?.bPrice?.text) &&
                      value.label.bPrice.text > 0
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.bPrice.line ? 'line pa-3' : null"
                      :style="{ color: value.photo.textColor }"
                    >
                      <span
                        class="d-flex align-items-center"
                        v-if="isValidValue(value.label?.discount?.text)"
                      >
                        قیمت نهایی :
                        <span
                          class="d-flex mx-2 justify-content-center align-items-center flex-column"
                        >
                          <pre
                            class="text-decoration-line-through ma-0 text-right"
                            v-html="
                              persian(value.label.bPrice.text?.toLocaleString())
                            "
                          ></pre>
                          <h6 class="text-right ma-0">
                            {{
                              persian(
                                (
                                  value.label.bPrice.text -
                                  value.label.discount.text *
                                    0.01 *
                                    value.label.bPrice.text
                                ).toLocaleString(),
                              )
                            }}
                          </h6>
                        </span>
                        <v-icon :color="value.pallete.textColor"
                          >mdi-currency-rial</v-icon
                        >
                      </span>
                      <pre v-else class="text-right my-2">
                        قیمت نهایی : {{ persian(value.label.bPrice.text?.toLocaleString()) }}
                        <v-icon :color="value.pallete.textColor">mdi-currency-rial</v-icon>
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'price' &&
                      isValidValue(value.label?.price?.text) &&
                      value.label.price.text > 0
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.price.line ? 'line pa-3' : null"
                      :style="{ color: value.photo.textColor }"
                    >
                      <pre class="text-right my-2">
                        قیمت تولید : {{ persian(value.label.price.text?.toLocaleString()) }}
                        <v-icon :color="value.pallete.textColor">mdi-currency-rial</v-icon>
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'cPrice' &&
                      isValidValue(value.label?.cPrice?.text) &&
                      value.label.cPrice.text > 0
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.cPrice.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        قیمت خرید مشتری : {{ persian(value.label.cPrice.text?.toLocaleString()) }}
                        <v-icon :color="value.pallete.textColor">mdi-currency-rial</v-icon>
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'discount' &&
                      isValidValue(value.label?.discount?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.discount.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-sale</v-icon>
                        تخفیف: {{ persian(value.label.discount.text?.toLocaleString()) }}%
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'production' &&
                      isValidValue(value.label?.production?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.production.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-calendar-range</v-icon>
                        تاریخ تولید: {{ getPersianDate(value.label.production.text) }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'expiration' &&
                      isValidValue(value.label?.expiration?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.expiration.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-calendar-range</v-icon>
                        تاریخ انقضا: {{ getPersianDate(value.label.expiration.text) }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'weigth' &&
                      isValidValue(value.label?.weigth?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.weigth.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-weight</v-icon>
                        وزن محصول: {{ persian(value.label.weigth.text) }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'size' && isValidValue(value?.label?.size?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.size.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-arrow-split-vertical</v-icon>
                        سایز محصول: {{ value.label.size.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'model' && isValidValue(value.label?.model?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.model.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-close-circle-outline</v-icon>
                        مدل محصول: {{ value.label.model.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'series' &&
                      isValidValue(value?.label?.series?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.series.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-close-circle-outline</v-icon>
                        سری ساخت محصول: {{ value.label.series.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'country' &&
                      isValidValue(value?.label?.country?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.country.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-flag</v-icon>
                        کشور ساخت : {{ value.label.country.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'producer' &&
                      isValidValue(value.label?.producer?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.producer.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-office-building-cog</v-icon>
                        نام تولید کننده محصول : {{ value.label.producer.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'brand' && isValidValue(value.label?.brand?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="value.label.brand.line ? 'line pa-3' : null"
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-basket-check</v-icon>
                        نام برند محصول : {{ value.label.brand.text }}
                      </pre>
                    </div>
                  </template>

                  <template
                    v-if="
                      item === 'discriptions' &&
                      isValidValue(value.label?.discriptions?.text)
                    "
                  >
                    <div
                      class="w-100 pt-1"
                      :class="
                        value.label.discriptions.line ? 'line pa-3' : null
                      "
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-text-box-edit</v-icon>
                        درباره محصول:
                        <span v-html="formattedText.slice(0, showMore)"> </span>
                        <br />
                      <span
                      v-if="value?.label?.discriptions?.text && value.label.discriptions.text.length > showMore"
                          @click="isExpanded = !isExpanded"
                          class="primary--text mt-2"
                          style="cursor: pointer !important; font-size: 12px; font-weight: bold;"
                        >
                          {{ isExpanded ? 'نمایش کمتر' : 'نمایش بیشتر ...' }}                        </span>
                      </pre>
                    </div>
                  </template>

                  <template v-if="item === 'arm' && value.label.arm?.text">
                    <div
                      class="w-100 pt-1 d-flex flex-column"
                      :class="
                        value.label.discriptions?.line ? 'line pa-3' : null
                      "
                    >
                      <pre class="text-right my-2">
                        <v-icon :color="value.pallete.textColor">mdi-image-check</v-icon>
                        نشان اعتماد:
                      </pre>
                      <v-card
                        class="d-flex align-items-center flex-wrap"
                        flat
                        color="transparent"
                      >
                        <v-card-text
                          class="mx-1 pa-0 my-1 border d-flex align-items-center"
                          color="transparent"
                          v-for="(card, i) in value.arm"
                          :key="i"
                        >
                          <v-img
                            :src="card.icon"
                            :aspect-ratio="1"
                            height="20"
                            max-width="20"
                          />
                          <v-card-subtitle
                            :style="{ color: value.pallete.textColor }"
                            class="mx-1 pa-0"
                            color="transparent"
                            >{{ card.name }}</v-card-subtitle
                          >
                        </v-card-text>
                      </v-card>
                    </div>
                  </template>

                  <!-- 
                    اضافه کردن overflow-hidden به والد تصاویر و ویدیوها 
                    برای جلوگیری از بیرون زدگی حاشیه‌های منفی (Negative Margins) کامپوننت داخلی
                  -->
                  <template
                    v-if="
                      item === 'img' &&
                      value.photo?.gallery?.[0]?.images?.length > 0
                    "
                  >
                    <div class="w-100 overflow-hidden rounded-lg my-2">
                      <image-slider v-model="value.photo.gallery" />
                    </div>
                  </template>

                  <template v-if="item === 'video' && !!value.label?.video">
                    <div
                      class="w-100 pt-0 mt-0 overflow-hidden rounded-lg my-2"
                    >
                      <b-gallery-view
                        v-if="
                          value &&
                          !!value.label.video &&
                          !!value.VideoGallery &&
                          value.VideoGallery.sectionColor
                        "
                        v-model="value.video_gallery"
                        :description="value.VideoGallery.description"
                        :is-img="false"
                        :settings="false"
                        :style="{
                          background:
                            value.VideoGallery.sectionColor.backGround,
                          color: value.VideoGallery.sectionColor.text,
                        }"
                        :title="value.VideoGallery.title"
                        type="video_gallery"
                      />
                    </div>
                  </template>

                  <template
                    v-if="
                      item &&
                      typeof item === 'string' &&
                      item.startsWith('more_')
                    "
                  >
                    <div
                      class="w-100"
                      :class="getMores(item).line ? 'line pb-3' : null"
                      @click="
                        getMores(item).link
                          ? goToUrl(getMores(item).link)
                          : null
                      "
                    >
                      <div class="text-right my-2">
                        <v-icon
                          v-if="getMores(item).icon"
                          :color="value.pallete.textColor"
                        >
                          {{ getMores(item).icon }}
                        </v-icon>
                        <span
                          v-if="getMores(item).label"
                          :style="{ color: value.pallete.textColor }"
                        >
                          {{ getMores(item).label }}:
                        </span>
                        <pre
                          class="text-right my-2 d-inline"
                          v-html="formattedText2(item)"
                        ></pre>
                      </div>
                    </div>
                  </template>
                </template>
              </drag-list>
            </div>
          </v-stepper-content>
          <v-stepper-content
            style="background: transparent"
            color="transparent"
            class="pa-0"
            step="2"
          >
            <v-card
              flat
              style="background: transparent"
              class="pa-2"
              :style="{ color: value.pallete.textColor }"
            >
              <v-card-actions class="w-100 pa-0 d-flex justify-content-start">
                <v-btn color="red" outlined @click="feedbackShow = 1">
                  <v-icon>mdi-chevron-right</v-icon>
                  بازگشت
                </v-btn>
              </v-card-actions>
              <b-feedback-label v-model="value.FeedBack" />
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>

<script>
import SaleTag from "./sales.vue";
import dragList from "../../qrland/dragList.vue";
import ImageSlider from "@/view/components/Gallery/imageSlider";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import bFeedbackLabel from "./bFeedbackLabel.vue";
import UniversalQrModal from "../../../components/UniversalQrModal.vue";

export default {
  name: "newFactoryLabel",
  components: { SaleTag, dragList, ImageSlider, BGalleryView, bFeedbackLabel,UniversalQrModal },
  props: {
    value: [Object],
    order: Array,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showQrDialog:false,
      socialMedia: [],
      socialMediaSlice: [],
      socialCount: 3,
      cardHeight: 0,
      isOverFlowLabel: false,
      isOverFlowLabelName: false,
      fixedWidth: 200,
      imageHeight: 500,
      feedbackicons: {
        img: "/media/socialIcon/feedback.png",
        label: "بازخورد",
        ext: "بازخورد",
      },
      feedbackShow: 1,
      showMore: 150,
      isExpanded: false, 
    };
  },

  watch: {
    "value.socialMedia": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) return;
        const objects = Object.keys(val);
        const slice = [];
        objects.forEach((item) => {
          if (Array.isArray(val[item])) {
            val[item].forEach((social) => {
              slice.push(social);
            });
          }
        });
        this.socialMedia = slice;
        this.socialMediaSlice = slice.slice(0, 2);
        this.setLabelKeys();
      },
    },
    "value.label": {
      deep: true,
      immediate: true,
      handler() {
        this.setLabelKeys();
      },
    },
    "value.label.labelName.text": {
      immediate: true,
      handler() {
        this.checkOverflow();
      },
    },
    "value.label.name.text": {
      immediate: true,
      handler() {
        this.checkOverflowName();
      },
    },
    "value.photo.background": {
      immediate: true,
      handler() {
        this.menuBackground();
      },
    },
    feedbackShow(val) {
      if (val == 1) {
        this.menuBackground();
      } else if (val == 2) {
        this.imageHeight = 489;
      }
    },
  },

  methods: {
    formattedText2(field) {
      let text;
      if (field && field.startsWith("more_")) {
        const index = parseInt(field.replace("more_", ""));
        text = this.value?.label?.more?.[index]?.text;
      } else {
        text = this.value?.label?.[field]?.text;
      }
      return typeof text === "string" ? text.replace(/\n/g, "<br>") : "";
    },
    getMores(item) {
      let index = parseInt(item.replace("more_", ""));
      return this.value.label?.more?.[index] || {};
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (url && !url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    addSocialMedia() {
      this.socialMediaSlice = this.socialMedia;
    },
    deletSocialMedia() {
      this.socialMediaSlice = this.socialMedia.slice(0, 2);
    },
    setLabelKeys() {
      if (!this.value || !this.value.label) return;
      let currentOrder = [...this.label];

      const validKeys = Object.keys(this.value.label).filter(
        (key) =>
          key !== "name" &&
          key !== "labelName" &&
          key !== "more" &&
          this.isValidValue(this.value.label[key]?.text),
      );

      const moreKeys =
        this.value.label?.more?.map((item, index) => `more_${index}`) || [];
      const allValidKeys = [...validKeys, ...moreKeys];

      let newOrder = currentOrder.filter((item) =>
        allValidKeys.includes(item.name),
      );

      allValidKeys.forEach((key) => {
        if (!newOrder.some((item) => item.name === key)) {
          newOrder.push({ name: key });
        }
      });

      if (JSON.stringify(newOrder) !== JSON.stringify(this.label)) {
        this.label = newOrder;
      }
    },
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "تاریخ نامعتبر";
      const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return formatter.format(date);
    },
    isValidValue(value) {
      if (value === null || value === undefined || value === "") return false;
      if (typeof value === "string") return value.trim().length > 0;
      if (typeof value === "number") return true; // عدد 0 هم معتبر است
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "boolean") return value;
      return !!value;
    },
    checkOverflow() {
      this.$nextTick(() => {
        const textEl = this.$refs.textRef;
        if (textEl) {
          this.isOverFlowLabel = textEl.scrollWidth > this.fixedWidth;
        }
      });
    },
    checkOverflowName() {
      this.$nextTick(() => {
        const textEl = this.$refs.textName;
        if (textEl) {
          this.isOverFlowLabelName = textEl.scrollWidth > this.fixedWidth;
        }
      });
    },
    menuBackground() {
      this.$nextTick(() => {
        let stepperHeight = this.$refs.myStepper?.$el?.offsetHeight;
        if (stepperHeight) {
          this.imageHeight = stepperHeight > 489 ? stepperHeight : 489;
        }
      });
    },
  },

  mounted() {
    const card = this.$refs.card_label;

    this.resizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        this.menuBackground();
      });
    });

    if (card && card.$el) {
      this.resizeObserver.observe(card.$el);
    } else if (card) {
      this.resizeObserver.observe(card);
    }

    this.checkOverflow();
    this.checkOverflowName();
    this.menuBackground();
    window.addEventListener("resize", this.checkOverflow);
    window.addEventListener("resize", this.checkOverflowName);
    window.addEventListener("resize", this.menuBackground);
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.checkOverflow);
    window.removeEventListener("resize", this.checkOverflowName);
    window.removeEventListener("resize", this.menuBackground);
  },

  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    label: {
      get() {
        return this.order;
      },
      set(val) {
        this.$emit("update:order", val);
      },
    },
 formattedText() {
      const text = this.value?.label?.discriptions?.text;
      if (typeof text !== "string") return "";
      
      if (!this.isExpanded && text.length > this.showMore) {
        let truncated = text.substring(0, this.showMore);
        truncated = truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf(" ")));
        return truncated.replace(/\n/g, "<br>") + " ...";
      }      
      return text.replace(/\n/g, "<br>");
    },  },
};
</script>

<style scoped>
.discount {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: red;
  position: absolute;
  z-index: 2;
  top: 14%;
  left: 0%;
  animation: linary 3s ease-in-out 0s 1 forwards;
}
.image_style {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  position: absolute;
  z-index: 2;
  right: -3%;
  top: -4%;
  animation: image-scale 3s ease-in-out 0s 1 forwards;
}

.social {
  animation: social-scale 3s ease-in-out 1 forwards;
}
.background_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  object-fit: cover;
  opacity: 0.1;
  z-index: 0;
  pointer-events: none;
  border-radius: 15px;
}
.badge-wrapper {
  position: absolute;
  left: 5%;
  top: 11%;
  z-index: 2;
  width: 100px;
  height: 100px;
  animation: linary 3s ease-in-out 0s 1 forwards;
}

.badge {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  background: repeating-conic-gradient(red 0deg 5deg, transparent 5deg 10deg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-shadow: 0 0 2px #000;
  animation: linary 3s ease-in-out 0s 1 forwards;
}

.badge::before {
  content: "";
  position: absolute;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  background: red;
  border-radius: 50%;
  z-index: 1;
}

.badge span {
  position: relative;
  z-index: 2;
}

.marquee-container {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.marquee-text {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 10s linear infinite;
}

.line {
  border-bottom: 1px solid rgb(206, 204, 204);
}

@keyframes marquee {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes linary {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.7;
  }
  80% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

@keyframes image-scale {
  0% {
    transform: translateX(-100px);
    opacity: 0.4;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.menu {
  position: absolute;
  bottom: 30%;
  left: 2%;
  animation: menu-scale 2s ease-in-out 0s 1 forwards;
}

@keyframes menu-scale {
  0% {
    transform: translateY(-100%);
    opacity: 0.4;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes social-scale {
  0% {
    transform: translateY(-200%);
    opacity: 0.5;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.scrollable-icons::-webkit-scrollbar {
  width: 6px;
}

.scrollable-icons::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
}

.scrollable-icons::-webkit-scrollbar-track {
  background: transparent;
}

/* برای Firefox */
.scrollable-icons {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
}
pre {
  white-space: normal;
  margin: 0.5em 0;
  direction: rtl;
  text-align: right;
  line-height: 1.2;
}
.qr-floating-btn {
  position: absolute;
  top: 10px;
  left: 44px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
